"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledTitle = exports.StyledTextWrapper = exports.StyledDescription = exports.StyledCardGroup = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _grid = require("../../fuse-responsive-grid/src/grid");
var _typography = require("../../fuse-typography-element/src/typography");
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
var StyledCardGroup = exports.StyledCardGroup = (0, _styledComponents["default"])(_grid.GridRow).withConfig({
  displayName: "styled-card-group__StyledCardGroup",
  componentId: "sc-11pr1id-0"
})(["&&{column-gap:var(--spacing-global-space5);row-gap:var(--spacing-global-space7);}"]);
var StyledTextWrapper = exports.StyledTextWrapper = (0, _styledComponents["default"])(_grid.GridItem).attrs({
  className: 'fuse-card-group__text-wrapper',
  'data-testid': 'fuse-card-group-text-wrapper'
}).withConfig({
  displayName: "styled-card-group__StyledTextWrapper",
  componentId: "sc-11pr1id-1"
})(["gap:var(--spacing-global-space3);display:flex;flex-direction:column;"]);
var StyledTitle = exports.StyledTitle = (0, _styledComponents["default"])(_typography.TypographyComponent).attrs({
  className: 'fuse-card-group__title',
  'data-testid': 'fuse-card-group-title'
}).withConfig({
  displayName: "styled-card-group__StyledTitle",
  componentId: "sc-11pr1id-2"
})(["margin-bottom:0;"]);
var StyledDescription = exports.StyledDescription = (0, _styledComponents["default"])(_typography.TypographyComponent).attrs({
  className: 'fuse-card-group__video-description',
  'data-testid': 'fuse-card-group-video-description'
}).withConfig({
  displayName: "styled-card-group__StyledDescription",
  componentId: "sc-11pr1id-3"
})(["margin-bottom:0;"]);